import * as React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card, ProgressBar } from 'react-bootstrap';
import VAPSTile from '../../PersonalInsurance/VAPSTile';
import ArcProgressBar from '../../ProgressBar/ArcProgressBar';
import './PolicyDetailsChilli.css';
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom';
import { MONTHLY_MILEAGE, DASHBOARD, PERSONAL_INSURANCE, CLAIMS, SELF_INSPECTION, FNOL, FNOL_SUBMIT_CLAIM } from '../../../routes/routes';
import { useState, useEffect } from 'react';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showComingSoon, showCallMeModal } from '../../../actions/modalActions';
import { Image } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { useCallback } from 'react'
import { syncCoverWithProfile } from '../../../actions/selfInspectActions';
import { CURR_CLAIMS } from '../../../constants/constants'
import { setCoverFromPersonalInsurance, clearSelectedDamages, resetFNOL, setStep  } from '../../../actions/claimSubmitActions';

const PolicyDetailsChilli = () => {
    const profileState = useSelector(state => state.profile);
    const cover = useSelector(state => state.profile.selectedPersonalCover)
    const dispatch = useDispatch();
    const [mileageReminderDismissed, updateMileageReminderDismissed] = useState(false);
    const [inspectionReminderDismissed, updateInspectionReminderDismissed] = useState(false);
    const [isInEdit, updateEditing] = useState(false);

    const premiumHistoryIncrement = 3;
    const [premiumHistory, updatePremiumHistory] = useState({
        count: -1,
        history: [],
    });

    const odoHistoryIncrement = 3;
    const [odoReadingHistory, updateOdoReadingHistory] = useState({
        count: -1,
        history: [],
    });

    const [chilliLevels, updateChilliLevels] = useState({
        count: -1,
        levels: [],
    });

    const loadPremiumHistory = useCallback(() => {
        return (cover.riskItems[0].chilliDetails.premiumHistoryList.filter((item) => item.index <= premiumHistory.count + premiumHistoryIncrement).map((item) =>
            <div className="form-group" key={item.index} >
                <div className="row">
                    <label className="col-sm-4 col-form-label">Description</label>
                    <div className="col-sm-8">
                        <p className="form-control-plaintext text-right">{item.calculatedDateRangeDescription}</p>
                    </div>
                </div>
                <div className="row">
                    <label className="col-sm-4 col-form-label">Chilli tier</label>
                    <div className="col-sm-8">
                        <p className="form-control-plaintext text-right">{item.chilliTier}</p>
                    </div>
                </div>
                <div className="row">
                    <label className="col-sm-4 col-form-label">Kms driven</label>
                    <div className="col-sm-8">
                        <p className="form-control-plaintext text-right">{item.kmDrivenInBand}km</p>
                    </div>
                </div>
                <div className="row">
                    <label className="col-sm-4 col-form-label">Max kms</label>
                    <div className="col-sm-8">
                        <p className="form-control-plaintext text-right">{item.maxKmInBand}km</p>
                    </div>
                </div>
                <div className="row">
                    <label className="col-sm-4 col-form-label">Premium</label>
                    <div className="col-sm-8">
                        <p className="form-control-plaintext text-right">{profileState.currencySymbol}{item.premium}</p>
                    </div>
                </div>
                <div className="row">
                    <label className="col-sm-4 col-form-label">Savings</label>
                    <div className="col-sm-8">
                        <p className="form-control-plaintext text-right">{profileState.currencySymbol}{item.savings}</p>
                    </div>
                </div>
                <div className="row">
                    <label className="col-sm-4 col-form-label">Billing date</label>
                    <div className="col-sm-8">
                        <p className="form-control-plaintext text-right">{item.billingDate}</p>
                    </div>
                </div>
                <hr />
            </div>
        ));
    }, [cover.riskItems, premiumHistory.count, profileState.currencySymbol]);

    const loadMorePremiumHistory = useCallback(() => {
        if (cover.riskItems[0].chilliDetails !== undefined) {
            updatePremiumHistory({
                count: premiumHistory.count + premiumHistoryIncrement,
                history: loadPremiumHistory()
            });
        }
    }, [cover.riskItems, loadPremiumHistory, updatePremiumHistory, premiumHistory.count]);

    const loadOdoReadingHistory = useCallback(() => {
        return (cover.riskItems[0].chilliDetails.odoReadingHistoryList.filter((item) => item.index <= odoReadingHistory.count + odoHistoryIncrement).map((item) =>
            <div className="form-group" key={item.index} >
                <p className="mb-0 mt-2"><b>Status</b></p>
                <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Submitted</label>
                    <div className="col-sm-6">
                        <p className="form-control-plaintext text-right">{item.history}</p>
                    </div>
                </div>
                <hr />
            </div>
        ));
    }, [cover.riskItems, odoReadingHistory.count]);

    const loadChilliLevels = useCallback(() => {
        return (cover.riskItems[0].chilliDetails.chilliLevels.map((item) =>
            <div className="form-group" key={item.chilliBand} >
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label"><b>{profileState.currencySymbol}{item.premium}pm</b></label>
                    <div className="col-sm-10">
                        <p className="form-control-plaintext text-right">{item.rangeDescription}</p>
                    </div>
                </div>
                <hr />
            </div>
        ));
    }, [cover.riskItems, profileState.currencySymbol]);

    const loadMoreOdoReadingHistory = useCallback(() => {
        if (cover.riskItems[0].chilliDetails !== undefined) {
            updateOdoReadingHistory({
                count: odoReadingHistory.count + odoHistoryIncrement,
                history: loadOdoReadingHistory()
            });
        }
    }, [cover.riskItems, updateOdoReadingHistory, odoReadingHistory.count, loadOdoReadingHistory]);

    useEffect(() => {
        if (premiumHistory.count === -1 && cover.riskItems[0].chilliDetails !== undefined) {
            loadMorePremiumHistory();
        }

        if (odoReadingHistory.count === -1 && cover.riskItems[0].chilliDetails !== undefined) {
            loadMoreOdoReadingHistory();
        }

        if (chilliLevels.count === -1 && cover.riskItems[0].chilliDetails !== undefined) {
            updateChilliLevels({
                count: cover.riskItems[0].chilliDetails.chilliLevels.length,
                levels: loadChilliLevels()
            });
        }
    }, [loadMorePremiumHistory, loadMoreOdoReadingHistory, loadChilliLevels, updateChilliLevels, chilliLevels.count, cover.riskItems, odoReadingHistory.count, premiumHistory.count])

    function redirectTo(destination) {
        dispatch(navigateTo(destination));
    };

    const [accordian0Open, updateAccordian0Open] = useState(false);
    const [accordian1Open, updateAccordian1Open] = useState(false);
    const [accordian2Open, updateAccordian2Open] = useState(false);
    const [accordian3Open, updateAccordian3Open] = useState(false);
    const [accordian4Open, updateAccordian4Open] = useState(false);
    const [accordian5Open, updateAccordian5Open] = useState(false);

    function handleAccordianArrow(e: any) {
        switch (e) {
            case 0:
                if (accordian0Open) {
                    updateAccordian0Open(false);
                }
                else {
                    updateAccordian0Open(true);
                }
                updateAccordian1Open(false);
                updateAccordian2Open(false);
                updateAccordian3Open(false);
                updateAccordian4Open(false);
                updateAccordian5Open(false);
                break;
            case 1:
                if (accordian1Open) {
                    updateAccordian1Open(false)
                }
                else {
                    updateAccordian1Open(true)
                }
                updateAccordian0Open(false);
                updateAccordian2Open(false);
                updateAccordian3Open(false);
                updateAccordian4Open(false);
                updateAccordian5Open(false);
                break;
            case 2:
                if (accordian2Open) {
                    updateAccordian2Open(false)
                }
                else {
                    updateAccordian2Open(true)
                }
                updateAccordian0Open(false);
                updateAccordian1Open(false);
                updateAccordian3Open(false);
                updateAccordian4Open(false);
                updateAccordian5Open(false);
                break;
            case 3:
                if (accordian3Open) {
                    updateAccordian3Open(false)
                }
                else {
                    updateAccordian3Open(true)
                }
                updateAccordian0Open(false);
                updateAccordian1Open(false);
                updateAccordian2Open(false);
                updateAccordian4Open(false);
                updateAccordian5Open(false);
                break;
            case 4:
                if (accordian4Open) {
                    updateAccordian4Open(false)
                }
                else {
                    updateAccordian4Open(true)
                }
                updateAccordian0Open(false);
                updateAccordian1Open(false);
                updateAccordian2Open(false);
                updateAccordian3Open(false);
                updateAccordian5Open(false);
                break;
            case 5:
                if (accordian5Open) {
                    updateAccordian5Open(false)
                }
                else {
                    updateAccordian5Open(true)
                }
                updateAccordian0Open(false);
                updateAccordian1Open(false);
                updateAccordian2Open(false);
                updateAccordian3Open(false);
                updateAccordian4Open(false);
                break;
            default:
        }
    }

    function editPolicyInfo() {
        dispatch(showComingSoon());
    }

    function cancelEdit() {
        updateEditing(false);
    }

    function saveEdit() {
        updateEditing(false);
    }

    function dismissMonthlyMileageReminder() {
        updateMileageReminderDismissed(true);
    }

    function dismissInspectionReminder() {
        updateInspectionReminderDismissed(true);
    }

    function handleSelfInspectionRequired() {
        dispatch(syncCoverWithProfile())
    }

    async function submitAClaim() {
        await dispatch(resetFNOL());
        await dispatch(clearSelectedDamages());
        await dispatch(setCoverFromPersonalInsurance(cover));
        await dispatch(setStep(1, 1));
        await dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    function handleCallMeBack() {
        dispatch(showCallMeModal(true));
    }

    const isMobile = window.innerWidth <= 975;
    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]

    let selfInspectionRequired = <>Self-inspection required.
        <Link id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder" to="#" onClick={handleSelfInspectionRequired} >Click here.</Link></>
    if (window.innerWidth < 359) {
        selfInspectionRequired = <> Self-inspection required.<br />
            <Link id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder" to="#" onClick={handleSelfInspectionRequired} >Click here.</Link></>
    }

    let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";

    return (
        <>
            {isMobile &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Chilli" />
            }
            <div className="box mb-3">
                {!mileageReminderDismissed && cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.odoUploadRequired &&
                    <div className="Reminder-banner">
                        <p className="Monthly-mileage-update">Monthly mileage update needed.
                    <Link id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder" to={MONTHLY_MILEAGE} >Click here.</Link>
                        </p>
                        <Image className="Reminder-banner-close-img" src="./images/icons-navigation-close-16-px-white.svg" alt="Dismiss" onClick={dismissMonthlyMileageReminder} />
                    </div>
                }
                {!inspectionReminderDismissed && cover.riskItems[0].inspectionRequired &&
                    <div className="Reminder-banner">
                        <p className="Monthly-mileage-update">{selfInspectionRequired}</p>
                        <Image className="Reminder-banner-close-img" src="./images/icons-navigation-close-16-px-white.svg" alt="Dismiss" onClick={dismissInspectionReminder} />
                    </div>
                }
                <div className="d-lg-block d-none" id="PolicyDetailsChilli">
                    <div className="pl-3 pr-3 pt-3">
                        <div id="DetailsDiv" className="border-bottom">
                            <div className="row mb-lg-0">
                                <div className="col-lg-7 col-md-8">
                                    <h2 className="carName mb-0">{cover.riskItems[0].description}</h2>
                                    <p className="mb-0">Chilli</p>
                                    <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div className="mb-3">
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                                <div className="col-lg-5 col-md-4 text-right">
                                    {!isInEdit &&
                                        <button className="btn btn-outline-red mb-3" onClick={editPolicyInfo} id="EditPolicy">Edit policy</button>
                                    }
                                    <br />
                                    <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                    {isInEdit &&
                                        <div className="">
                                            <div className="mt-3 mb-3">
                                                <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                                <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-7">

                                </div>
                                <div className="col-lg-5 text-right">

                                </div>

                            </div>

                            <div className="row">
                                <div className="col-lg-12 col-12">
                                    <div className="row">
                                        <div className="ml-3 mr-3">
                                            <img src="./images/Dashboard/icon-chilli-logo-small-copy-2.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {cover.riskItems[0].inspectionRequired &&
                                <div className="row">
                                    <div className="col-lg-12 text-right mb-2 mt-2">
                                        <button className="btn self-inspection-button" onClick={handleSelfInspectionRequired}>Self-inspection required</button>
                                    </div>
                                </div>
                            }
                        </div>
                        <div id="MonthlyMileage" className="border-bottom mt-3">
                            <div className="row mb-lg-0 pl-3">
                                <div className="col-5">
                                    <h6 className="">Monthly mileage</h6>
                                    <p className="Your-chilli-premium">Your chilli premium is based on your car's monthly mileage (aka how many kms you drive in a month) so it's super important that you give us this info</p>
                                </div>
                                <div className="col-7 mb-3 text-right">
                                    <button className="btn btn-solid-red w-auto" onClick={() => redirectTo(MONTHLY_MILEAGE)}>Submit monthly mileage update</button>
                                </div>
                            </div>
                        </div>
                        <div className="d-block d-lg-none d-md-block mt-3">
                            <div id="NextPremium">
                                <p className="title mb-1">Your next premium</p>
                                <p className="Calculated mb-1">{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.calculatedDateRangeDescription}</p>
                                <p className="amount">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined ? cover.riskItems[0].chilliDetails.estimatedNextPremium : 0.00}</p>
                            </div>
                            <div id="Estimated">
                                <p className="title mb-1">Estimated savings</p>
                                <p className="amount">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined ? cover.riskItems[0].chilliDetails.estimatedSavings: 0.00}</p>
                            </div>
                        </div>
                        <div className="mb-2">
                            <div className="mt-3 text-center">
                                <p className="Last-updated">Last updated:&nbsp; <b>{cover.riskItems[0].chilliDetails !== undefined ? cover.riskItems[0].chilliDetails.lastUpdated  : "N/A"}</b></p>
                                <ArcProgressBar value={cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.monthlyMileagePercentage / 100} width={0.6} omega={60} />
                                <div className="km">
                                    <h1 className="mb-3">{cover.riskItems[0].chilliDetails !== undefined ? cover.riskItems[0].chilliDetails.kmDrivenInBand : 0}</h1>
                                    <span className="km-driven">km driven</span>
                                </div>
                            </div>
                            <div className="d-none d-lg-block d-md-none text-center">
                                <div className="row" id="details">
                                    <div className="col-lg-4">
                                        <p className="title mb-1">Your next premium</p>
                                        <p className="premium">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.estimatedNextPremium}</p>
                                        <div>
                                            <ProgressBar id="ProgressPremium" now={cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.nextPremiumPercentage} />
                                            <p className="Calculated mt-1">{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.calculatedDateRangeDescription}</p>
                                        </div>
                                        <p className="title">Details</p>
                                        <p className="detailsDetail">We’ll debit this amount from your account on the debit day you chose.</p>
                                    </div>
                                    <div className="col-lg-4 border-left border-right">
                                        <p className="title mb-1">Estimated savings</p>
                                        <p className="excess">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.estimatedSavings}</p>
                                        <div>
                                            <ProgressBar id="ProgressEstimate" now={cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.estimatedSavingsPercentage} />
                                            <br />
                                            <br />
                                        </div>
                                        <p className="title">Details</p>
                                        {cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.estimatedSavingsPercentage === 0 &&
                                            <p className="detailsDetail">Your max monthly premium is {profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.maxPremium}, based on the mileage you gave us ({cover.riskItems[0].chilliDetails.maxRangeDescription}).</p>
                                        }
                                        {cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.estimatedSavingsPercentage !== 0 &&
                                            <p className="detailsDetail">Your max monthly premium is {profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.maxPremium}, based on the mileage you gave us ({cover.riskItems[0].chilliDetails.maxRangeDescription}). Because you drove less than that this month, you’ve saved {profileState.currencySymbol}{cover.riskItems[0].chilliDetails.estimatedSavings}.</p>
                                        }
                                    </div>
                                    <div className="col-lg-4">
                                        <p className="title mb-1">Monthly mileage</p>
                                        <p className="mileage">{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.kmDrivenInBand}km</p>
                                        <div>
                                            <ProgressBar id="ProgressMileage" now={cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.monthlyMileagePercentage} />
                                            <br />
                                            <br />
                                        </div>
                                        <p className="title">Details</p>
                                        <p className="detailsDetail">{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.actualKmDrivenDateRangeDescription}.</p>
                                        <p className="Calculated">Last updated: <b>{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.lastUpdated}</b></p>
                                    </div>
                                </div>
                            </div>
                            {false &&
                                <div className="d-block d-lg-none d-md-block mb-4 text-center">
                                    <button className="btn btn-outline-red">View more extras</button>
                                </div>
                            }
                        </div>
                        <div className="border-top border-bottom">
                            <div className="my-3 text-lg-center">
                                <p className="mb-0 Excess"><b>Excess amount</b></p>
                                <p className="ExcessAmount mb-1">{profileState.currencySymbol}{cover.excess}</p>
                                <p className="Insured-retail-value">Insured retail value</p>
                            </div>
                        </div>
                        <div id="OptionalExtras" className="mt-lg-4">
                            <p className="Benefits">Optional cover</p>
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCarHire ? 'icons-vap-icons-car-hire-active' : 'icons-vap-icons-car-hire-inactive'} productName="Car hire" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCarHire} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="Car-hire" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCarHire} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapKingsCab ? 'icons-vap-icons-kings-cab-active' : 'icons-vap-icons-kings-cab-inactive'} productName="The king’s cab" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapKingsCab} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="king’s-cab" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapKingsCab} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapScratchAndDent ? 'icons-vap-icons-scratch-and-dent-active' : 'icons-vap-icons-scratch-and-dent-inactive'} productName="Scratch and dent" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapScratchAndDent} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="Scratch-and-dent" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapScratchAndDent} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCreditShortfall ? 'icons-vap-icons-credit-shortfall-active' : 'icons-vap-icons-credit-shortfall-inactive'} productName="Credit shortfall" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCreditShortfall} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="Credit-shortfall" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCreditShortfall} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            {false &&
                                <div className="text-lg-right text-center my-3">
                                    <button className="btn btn-outline-red">View more extras</button>
                                </div>
                            }
                        </div>
                        <div id="Accessories" className="mt-lg-4">
                            <p className="Benefits">Accessories</p>
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) !== undefined ? 'icons-vap-icons-mags-and-rims-active' : 'icons-vap-icons-mags-and-rims-inactive'} productName="Mags and rims" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) !== undefined && cover.accessories.find(e => e.carAccessoryTypeId === 2).replacementValue !== -1 && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 2).replacementValue}</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) !== undefined && cover.accessories.find(e => e.carAccessoryTypeId === 2).replacementValue === -1 && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 2).carAccessoryTypeDescription}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="MagsRims" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 29) !== undefined ? 'icons-vap-icons-smash-and-grab-active' : "icons-vap-icons-smash-and-grab-inactive"} productName="Smash and grab" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 29) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 29) !== undefined && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 29).replacementValue}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="SmashGrab" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 26) !== undefined ? 'icons-vap-icons-leather-seats-active' : "icons-vap-icons-leather-seats-inactive"} productName="Leather seats" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 26) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 26) !== undefined && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 26).replacementValue}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="Leatherseats" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 40) !== undefined ? 'icons-vap-icons-canopy-active' : "icons-vap-icons-canopy-inactive"} productName="Canopy" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 40) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 40) !== undefined && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 40).replacementValue}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="Canopy" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            {isInEdit &&
                                <div className="text-lg-right text-center my-4 mb-5">
                                    <button className="btn btn-solid-green AddAccessory">Add accessory</button>
                                </div>
                            }
                        </div>
                        <div id="DetailsDiv" className="mt-lg-4 pb-3">
                            <Accordion>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => handleAccordianArrow(0)}>
                                        <p className="CardTitle">How it works</p>
                                        <Image className={"accordian-arrow" + (accordian0Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body>
                                            <div className="form-group mt-2">
                                                <label><b>Estimated saving</b></label>
                                                <p className="mt-2">Your first monthly premium will be based on the value of your car and the monthly mileage you told us about when you took out this cover.</p>
                                                <p>Your premium will change every month depending on your previous month's actual mileage, the excess you choose, and your individual risk profile.</p>
                                                <hr />
                                            </div>
                                            {chilliLevels.levels}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => handleAccordianArrow(1)}>
                                        <p className="CardTitle">Regular driver</p>
                                        <Image className={"accordian-arrow" + (accordian1Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Name</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.firstName}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Surname</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.surname}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">ID no.</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.idNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Date of birth</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.dateOfBirth}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Licence type</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.licenseCode}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Licence year</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.licenseIssueDate}</p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => handleAccordianArrow(2)}>
                                        <p className="CardTitle">Car details</p>
                                        <Image className={"accordian-arrow" + (accordian2Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="2">
                                        <Card.Body>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Year</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.year}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Colour</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.colour}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Reg no.</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.registrationNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Vin no.</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vinNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Engine no.</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.engineNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Use</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleUse}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Imported</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleImported}</p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="3" onClick={() => handleAccordianArrow(3)}>
                                        <p className="CardTitle">Insurance history</p>
                                        <Image className={"accordian-arrow" + (accordian3Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="3">
                                        <Card.Body>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Full comprehensive insurance</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].insuranceDuration}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Last stolen claim</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].lastStolenClaim}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Last accident claim</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].lastAccidentClaim}</p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="4" onClick={() => handleAccordianArrow(4)}>
                                        <p className="CardTitle">Premium history</p>
                                        <Image className={"accordian-arrow" + (accordian4Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="4">
                                        <Card.Body>
                                            {premiumHistory.history}
                                            <div className="text-lg-right text-center my-3">
                                                <button className="btn btn-outline-red" disabled={premiumHistory.count > premiumHistory.history.length} onClick={loadMorePremiumHistory}>Load more</button>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="5" onClick={() => handleAccordianArrow(5)}>
                                        <p className="CardTitle">Mileage reading history</p>
                                        <Image className={"accordian-arrow" + (accordian5Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="5">
                                        <Card.Body>
                                            {odoReadingHistory.history}
                                            <div className="text-lg-right text-center my-3">
                                                <button className="btn btn-outline-red" disabled={odoReadingHistory.count > odoReadingHistory.history.length} onClick={loadMoreOdoReadingHistory}>Load more</button>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                    </div>
                </div>
                <div className="d-lg-none d-block" id="PolicyDetailsMobile" style={{ display: "none" }}>
                    <div className="pl-3 pr-3">
                        <div id="firstDivMobile" className="border-bottom">
                            <h2 className="carName mb-0 pt-3">{cover.riskItems[0].description}</h2>
                            <div className="row">
                                <div className="col-12">
                                    <p className="mb-0">Chilli</p>
                                    <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div className="mb-3">
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-2">
                                    <img src="./images/Dashboard/icon-chilli-logo-small-copy-2.png" alt="" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <button className="btn btn-outline-red" onClick={editPolicyInfo} >Edit policy</button>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                </div>
                            </div>
                            <div className="row mb-4">
                                {cover.riskItems[0].inspectionRequired &&
                                    <div className="col-12">
                                        <button className="btn btn-solid-red" onClick={handleSelfInspectionRequired}>Self-inspection required</button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="border-bottom mt-3">
                            <div id="MonthlyMileage" className="col-12">
                                <h6 className="">Monthly mileage</h6>
                                <p className="Your-chilli-premium">Your chilli premium is based on your car's monthly mileage (aka how many kms you drive in a month) so it's super important that you give us this info</p>
                            </div>
                            <div className="row mb-4">
                                <div className="col-12">
                                    <button className="btn btn-solid-red" onClick={() => redirectTo(MONTHLY_MILEAGE)}>Submit monthly mileage update</button>
                                </div>
                            </div>
                        </div>
                        <div className="d-block d-lg-none d-md-block mt-3">
                            <div id="NextPremium">
                                <p className="title mb-1">Your next premium</p>
                                <p className="Calculated mb-1">{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.calculatedDateRangeDescription}</p>
                                <p className="amount">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.estimatedNextPremium}</p>
                            </div>
                            <div id="Estimated">
                                <p className="title mb-1">Estimated savings</p>
                                <p className="amount">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.estimatedSavings}</p>
                            </div>
                        </div>
                        <div className="mb-2">
                            <div className="mt-3 text-center">
                                <p className="Last-updated">Last updated:&nbsp; <b>{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.lastUpdated}</b></p>
                                <ArcProgressBar value={cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.monthlyMileagePercentage / 100} width={0.6} omega={60} />
                                <div className="km">
                                    <h1 className="mb-3">{cover.riskItems[0].chilliDetails !== undefined && cover.riskItems[0].chilliDetails.kmDrivenInBand}</h1>
                                    <span className="km-driven">km driven</span>
                                </div>
                            </div>
                            <div className="d-none d-lg-block d-md-none text-center">
                                <div className="row" id="details">
                                    <div className="col-lg-4">
                                        <p className="title mb-1">Your next premium</p>
                                        <p className="premium">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails.estimatedNextPremium}</p>
                                        <div>
                                            <ProgressBar id="ProgressPremium" now={cover.riskItems[0].chilliDetails.nextPremiumPercentage} />
                                            <p className="Calculated mt-1">{cover.riskItems[0].chilliDetails.calculatedDateRangeDescription}</p>
                                        </div>
                                        <p className="title">Details</p>
                                        <p className="detailsDetail">We’ll debit this amount from your account on the debit day you chose.</p>
                                    </div>
                                    <div className="col-lg-4 border-left border-right">
                                        <p className="title mb-1">Estimated savings</p>
                                        <p className="excess">{profileState.currencySymbol}{cover.riskItems[0].chilliDetails.estimatedSavings}</p>
                                        <div>
                                            <ProgressBar id="ProgressEstimate" now={cover.riskItems[0].chilliDetails.estimatedSavingsPercentage} />
                                            <br />
                                            <br />
                                        </div>
                                        <p className="title">Details</p>
                                        {cover.riskItems[0].chilliDetails.estimatedSavingsPercentage === 0 &&
                                            <p className="detailsDetail">Your max monthly premium is {profileState.currencySymbol}{cover.riskItems[0].chilliDetails.maxPremium}, based on the mileage you gave us ({cover.riskItems[0].chilliDetails.maxRangeDescription}).</p>
                                        }
                                        {cover.riskItems[0].chilliDetails.estimatedSavingsPercentage !== 0 &&
                                            <p className="detailsDetail">Your max monthly premium is {profileState.currencySymbol}{cover.riskItems[0].chilliDetails.maxPremium}, based on the mileage you gave us ({cover.riskItems[0].chilliDetails.maxRangeDescription}). Because you drove less than that this month, you’ve saved {profileState.currencySymbol}{cover.riskItems[0].chilliDetails.estimatedSavings}.</p>
                                        }
                                    </div>
                                    <div className="col-lg-4">
                                        <p className="title mb-1">Monthly mileage</p>
                                        <p className="mileage">{cover.riskItems[0].chilliDetails.kmDrivenInBand}km</p>
                                        <div>
                                            <ProgressBar id="ProgressMileage" now={cover.riskItems[0].chilliDetails.monthlyMileagePercentage} />
                                            <br />
                                            <br />
                                        </div>
                                        <p className="title">Details</p>
                                        <p className="detailsDetail">{cover.riskItems[0].chilliDetails.actualKmDrivenDateRangeDescription}.</p>
                                        <p className="Calculated">Last updated: <b>{cover.riskItems[0].chilliDetails.lastUpdated}</b></p>
                                    </div>
                                </div>
                            </div>
                            {false &&
                                <div className="d-block d-lg-none d-md-block mb-4 text-center">
                                    <button className="btn btn-outline-red">View more extras</button>
                                </div>
                            }
                        </div>
                        <div className="border-top border-bottom">
                            <div className="my-3 text-lg-center">
                                <p className="mb-0 Excess"><b>Excess amount</b></p>
                                <p className="ExcessAmount mb-1">{profileState.currencySymbol}{cover.excess}</p>
                                <p className="Insured-retail-value">Insured retail value</p>
                            </div>
                        </div>
                        <div id="OptionalExtras" className="mt-lg-4">
                            <p className="Benefits">Optional cover</p>
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCarHire ? 'icons-vap-icons-car-hire-active' : 'icons-vap-icons-car-hire-inactive'} productName="Car hire" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCarHire} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="Car-hire" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCarHire} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapKingsCab ? 'icons-vap-icons-kings-cab-active' : 'icons-vap-icons-kings-cab-inactive'} productName="The king’s cab" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapKingsCab} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="king’s-cab" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapKingsCab} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapScratchAndDent ? 'icons-vap-icons-scratch-and-dent-active' : 'icons-vap-icons-scratch-and-dent-inactive'} productName="Scratch and dent" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapScratchAndDent} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="Scratch-and-dent" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapScratchAndDent} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCreditShortfall ? 'icons-vap-icons-credit-shortfall-active' : 'icons-vap-icons-credit-shortfall-inactive'} productName="Credit shortfall" hasVAP={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCreditShortfall} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4">
                                    <label className="switch float-right">
                                        <input type="checkbox" id="Credit-shortfall" disabled={!isInEdit} checked={cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vapCreditShortfall} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr className="mt-0" />
                            {false &&
                                <div className="text-lg-right text-center my-3">
                                    <button className="btn btn-outline-red">View more extras</button>
                                </div>
                            }
                        </div>
                        <div id="Accessories" className="mt-lg-4">
                            <p className="Benefits">Accessories</p>
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) !== undefined ? 'icons-vap-icons-mags-and-rims-active' : 'icons-vap-icons-mags-and-rims-inactive'} productName="Mags and rims" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) !== undefined && cover.accessories.find(e => e.carAccessoryTypeId === 2).replacementValue !== -1 && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 2).replacementValue}</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 2) !== undefined && cover.accessories.find(e => e.carAccessoryTypeId === 2).replacementValue === -1 && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 2).carAccessoryTypeDescription}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="MagsRims" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 29) !== undefined ? 'icons-vap-icons-smash-and-grab-active' : "icons-vap-icons-smash-and-grab-inactive"} productName="Smash and grab" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 29) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 29) !== undefined && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 29).replacementValue}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="SmashGrab" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 26) !== undefined ? 'icons-vap-icons-leather-seats-active' : "icons-vap-icons-leather-seats-inactive"} productName="Leather seats" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 26) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 26) !== undefined && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 26).replacementValue}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="Leatherseats" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            <div className="row py-2">
                                <div className="col-lg-6 col-8">
                                    <VAPSTile imageClass={cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 40) !== undefined ? 'icons-vap-icons-canopy-active' : "icons-vap-icons-canopy-inactive"} productName="Canopy" hasVAP={false} VAPCode="" />
                                </div>
                                <div className="col-lg-6 col-4 text-right">
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 40) === undefined && !isInEdit &&
                                        <p><b>N/A</b></p>
                                    }
                                    {cover.accessories && cover.accessories.find(e => e.carAccessoryTypeId === 40) !== undefined && !isInEdit &&
                                        <p><b>{profileState.currencySymbol}{cover.accessories.find(e => e.carAccessoryTypeId === 40).replacementValue}</b></p>
                                    }
                                    {isInEdit &&
                                        <div className="row">
                                            <div className="col-lg-8 col-8 pr-lg-0">
                                                <input type="text" className="form-control" id="Canopy" placeholder="Value" />
                                            </div>
                                            <div className="col-lg-4 col-4 pl-0">
                                                <button type="submit" className="btn btn-solid-green mb-2">Add</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="mt-0" />
                            {isInEdit &&
                                <div className="text-lg-right text-center my-4 mb-5">
                                    <button className="btn btn-solid-green AddAccessory">Add accessory</button>
                                </div>
                            }
                        </div>
                        <div id="DetailsDiv" className="mt-lg-4 pb-3">
                            <Accordion>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => handleAccordianArrow(0)}>
                                        <p className="CardTitle">How it works</p>
                                        <Image className={"accordian-arrow" + (accordian0Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <Card.Body>
                                            <div className="form-group mt-2">
                                                <label><b>Estimated saving</b></label>
                                                <p className="mt-2">Your first monthly premium will be based on the value of your car and the monthly mileage you told us about when you took out this cover.</p>
                                                <p>Your premium will change every month depending on your previous month's actual mileage, the excess you choose, and your individual risk profile.</p>
                                                <hr />
                                            </div>
                                            {chilliLevels.levels}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => handleAccordianArrow(1)}>
                                        <p className="CardTitle">Regular driver</p>
                                        <Image className={"accordian-arrow" + (accordian1Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Name</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.firstName}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Surname</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.surname}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">ID no.</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.idNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Date of birth</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.dateOfBirth}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Licence type</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.licenseCode}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Licence year</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].regularDriver && cover.riskItems[0].regularDriver.licenseIssueDate}</p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => handleAccordianArrow(2)}>
                                        <p className="CardTitle">Car details</p>
                                        <Image className={"accordian-arrow" + (accordian2Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="2">
                                        <Card.Body>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Year</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.year}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Colour</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.colour}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Registration number</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.registrationNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Vin number</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vinNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Engine number</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.engineNumber}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Vehicle use</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleUse}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-6 col-form-label">Vehicle imported</label>
                                                <div className="col-sm-6">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleImported}</p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="3" onClick={() => handleAccordianArrow(3)}>
                                        <p className="CardTitle">Insurance history</p>
                                        <Image className={"accordian-arrow" + (accordian3Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="3">
                                        <Card.Body>
                                            <div>
                                                <p className="col-form-label">Full comprehensive insurance</p>
                                                <p className="form-control-plaintext">{cover.riskItems[0].insuranceDuration}</p>
                                            </div>
                                            <div>
                                                <p className="col-form-label">Last stolen claim</p>
                                                <p className="form-control-plaintext">{cover.riskItems[0].lastStolenClaim}</p>
                                            </div>
                                            <div>
                                                <p className="col-form-label">Last accident claim</p>
                                                <p className="form-control-plaintext">{cover.riskItems[0].lastAccidentClaim}</p>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="4" onClick={() => handleAccordianArrow(4)}>
                                        <p className="CardTitle">Premium history</p>
                                        <Image className={"accordian-arrow" + (accordian4Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="4">
                                        <Card.Body>
                                            {premiumHistory.history}
                                            <div className="text-lg-right text-center my-3">
                                                <button className="btn btn-outline-red" disabled={premiumHistory.count > premiumHistory.history.length} onClick={loadMorePremiumHistory}>Load more</button>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="5" onClick={() => handleAccordianArrow(5)}>
                                        <p className="CardTitle">Mileage reading history</p>
                                        <Image className={"accordian-arrow" + (accordian5Open ? ' isRotated' : '')} src="./images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="5">
                                        <Card.Body>
                                            {odoReadingHistory.history}
                                            <div className="text-lg-right text-center my-3">
                                                <button className="btn btn-outline-red" disabled={odoReadingHistory.count > odoReadingHistory.history.length} onClick={loadMoreOdoReadingHistory}>Load more</button>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
            <Card className="mt-3 mb-5">
                <Card.Body>
                    <div className="row">
                        <div className="col-lg-2 col-3">
                            <div className="chilli"></div>
                        </div>
                        <div className="col-lg-10 col-9">
                            <div className="row">
                                <div className="col-10 px-0 mt-3">
                                    <p className="mb-0"><b>Add chilli insurance</b></p>
                                </div>
                                <div className="col-2 mt-2 pl-0 pl-lg-2" style={{ paddingTop: "2px" }}>
                                    <Image src="./Images/TopNav/add-cover-nugreen-46px-46px.svg" className="mx-auto d-block cursor-pointer" onClick={handleCallMeBack} style={{ height: "30px" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}
export default connect(mapStateToProps)(PolicyDetailsChilli);
